module.exports = __webpack_public_path__ + "img/section4-3-desktop.b9a880a4.png";